import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14930">
      <span className="sr-only" data-id="element-14931">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-14932">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-14933" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-14934" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-14935">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-14936">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-14937" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-14938" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-14939" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-14940">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-14941">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-14942" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-14943" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-14944">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-14945">
            <thead data-id="element-14946">
              <tr data-id="element-14947">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-14948">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-14949" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-14950">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-14951">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-14952">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14953" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-14954">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-14955" />
          <div className="flex gap-2" data-id="element-14956">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-14957" />)}
          </div>
        </div>
      </div>
    </div>;
}